(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ed-product-hero')) {
    customElements.define('ed-product-hero', class extends HTMLElement {
      static editorSelection = new Map();
      get transitionSpeed() { return this.reducedMotion.matches || this.dataset.animate !== 'true' || this.dataset.editor === 'true' ? 0 : 500; }
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.slides = Array.from(this.querySelectorAll('.ed-hero__slide'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const selectedBlock = this.dataset.editor === 'true' ? this.constructor.editorSelection.get(this.dataset.sectionId) : null;
        this.pendingIndex = Math.max(0, this.slides.findIndex(slide => slide.dataset.blockId === selectedBlock));
        this.titleIndex = -1;
        this.brandIndex = -1;
        const options = { signal: this.abort.signal };
        this.addEventListener('click', (event) => {
          const previous = event.target.closest('[data-hero-prev]');
          const next = event.target.closest('[data-hero-next]');
          if (previous || next) this.advance(previous ? -1 : 1);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input, textarea, select, [contenteditable]')) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.advance(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index < 0) return;
          this.pendingIndex = index;
          this.promote(this.slides[index]);
          if (this.swiper) this.swiper.slideTo(index, 0);
          else this.sync(index, false);
        }, options);
        this.addEventListener('load', (event) => {
          if (event.target.matches('.ed-hero__image') && event.target.closest('.ed-hero__slide')?.getAttribute('aria-hidden') !== 'true') {
            this.swiper?.updateAutoHeight(0);
            this.queueNextImage(this.swiper?.activeIndex ?? this.pendingIndex);
          }
        }, { ...options, capture: true });
        document.querySelector('script[src*="swiper-bundle"]')?.addEventListener('load', () => this.initialize(), options);
        window.addEventListener('load', () => this.initialize(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { clearTimeout(this.warmup); this.finishTitle?.(); this.finishBrand(); }
          else this.queueNextImage(this.swiper?.activeIndex ?? this.pendingIndex);
        }, options);
        this.reducedMotion.addEventListener('change', () => {
          this.finishTitle?.();
          this.finishBrand();
          if (this.swiper) this.swiper.params.speed = this.transitionSpeed;
        }, options);
        this.sync(this.pendingIndex, false);
        this.initialize();
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.swiper?.updateAutoHeight(0);
        });
      }
      initialize() {
        if (!this.isConnected || this.swiper || this.slides.length < 2 || typeof window.Swiper !== 'function') return;
        const index = Math.min(this.pendingIndex, this.slides.length - 1);
        this.setAttribute('data-ready', '');
        try {
          this.swiper = new window.Swiper(this.querySelector('.ed-hero__viewport'), {
          slidesPerView: 1,
          initialSlide: index,
          speed: this.transitionSpeed,
          rewind: true,
          loop: false,
          autoHeight: true,
          grabCursor: true,
          a11y: false,
          on: {
            slideChange: (swiper) => this.sync(swiper.activeIndex),
            resize: () => { this.finishTitle?.(); this.finishBrand(); this.swiper?.updateAutoHeight(0); }
          }
          });
          this.sync(index, false);
        } catch (error) {
          this.querySelector('.ed-hero__viewport').swiper?.destroy(true, true);
          this.swiper = null;
          this.removeAttribute('data-ready');
          this.sync(index, false);
          console.warn('Product hero: carousel unavailable; static slide retained.', error);
        }
      }
      promote(slide, priority = 'auto') {
        if (!slide) return;
        slide.querySelectorAll('source[data-srcset]').forEach(source => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
        slide.querySelectorAll('img[data-src]').forEach(image => {
          image.setAttribute('fetchpriority', priority);
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
          image.removeAttribute('data-srcset');
        });
        if (priority !== 'low') slide.querySelector('img[fetchpriority="low"]')?.setAttribute('fetchpriority', 'auto');
      }
      queueNextImage(index) {
        clearTimeout(this.warmup);
        if (!this.swiper || document.hidden || this.slides.length < 2 || navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
        const image = this.slides[index]?.querySelector('.ed-hero__image');
        if (image && !image.complete) return;
        this.warmup = setTimeout(() => {
          if (this.isConnected) this.promote(this.slides[(index + 1) % this.slides.length], 'low');
        }, 800);
      }
      advance(direction) {
        if (!this.swiper) return;
        const index = (this.swiper.activeIndex + direction + this.slides.length) % this.slides.length;
        const focused = document.activeElement;
        const focusSelector = focused?.hasAttribute('data-hero-prev') ? '[data-hero-prev]' : focused?.hasAttribute('data-hero-next') ? '[data-hero-next]' : focused?.classList.contains('ed-hero__button') ? '.ed-hero__button' : focused?.classList.contains('ed-hero__image-link') ? '.ed-hero__image-link' : null;
        this.promote(this.slides[index]);
        this.swiper.slideTo(index);
        if (focusSelector) (this.slides[index].querySelector(focusSelector) || this.slides[index].querySelector('[data-hero-next]') || this.slides[index]).focus({ preventScroll: true });
      }
      sync(index, announce = true) {
        if (!this.slides[index]) return;
        this.pendingIndex = index;
        this.dataset.presentation = this.slides[index].dataset.slidePresentation || this.dataset.presentation;
        this.dataset.mobilePresentation = this.slides[index].dataset.slideMobilePresentation || this.dataset.mobilePresentation;
        if (this.dataset.editor === 'true') this.constructor.editorSelection.set(this.dataset.sectionId, this.slides[index].dataset.blockId);
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          if (!active && slide.contains(document.activeElement)) document.activeElement.blur();
          slide.inert = !active;
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.revealTitle(index);
        this.revealBrand(index);
        this.promote(this.slides[index]);
        this.queueNextImage(index);
        this.swiper?.updateAutoHeight(this.transitionSpeed);
        if (announce) this.querySelector('[data-hero-status]').textContent = this.slides[index].getAttribute('aria-label');
      }
      revealTitle(index) {
        if (this.titleIndex === index) return;
        this.finishTitle?.();
        this.titleIndex = index;
        const title = this.slides[index]?.querySelector('.ed-hero__title');
        const out = title?.querySelector('[data-hero-type-out]');
        const text = title?.getAttribute('aria-label');
        if (!out || !text || !this.transitionSpeed || document.hidden) return;
        const letters = typeof Intl.Segmenter === 'function' ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text), part => part.segment) : Array.from(text);
        const originalHeight = title.style.minHeight;
        title.style.minHeight = title.getBoundingClientRect().height + 'px';
        let frame, ended = false;
        const start = performance.now();
        this.finishTitle = () => {
          if (ended) return;
          ended = true;
          cancelAnimationFrame(frame);
          out.textContent = text;
          title.style.minHeight = originalHeight;
        };
        const tick = now => {
          if (!this.isConnected || this.reducedMotion.matches || now - start >= 560) { this.finishTitle(); return; }
          out.textContent = letters.slice(0, Math.max(1, Math.ceil(letters.length * (now - start) / 560))).join('');
          frame = requestAnimationFrame(tick);
        };
        tick(start);
      }
      finishBrand() {
        this.brandRevealToken = (this.brandRevealToken || 0) + 1;
        this.brandAnimation?.cancel();
        this.brandAnimation = null;
      }
      revealBrand(index) {
        if (this.brandIndex === index) return;
        this.finishBrand();
        this.brandIndex = index;
        const logo = this.slides[index]?.querySelector('.ed-hero__brand img');
        if (!logo || !this.transitionSpeed || document.hidden || typeof logo.animate !== 'function') return;
        const token = this.brandRevealToken;
        const reveal = () => {
          if (!this.isConnected || token !== this.brandRevealToken || !this.transitionSpeed || document.hidden) return;
          this.brandAnimation = logo.animate([
            { opacity: 0, transform: 'translateY(6px)' },
            { opacity: 1, transform: 'translateY(0)' }
          ], { duration: 360, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' });
        };
        if (logo.complete && logo.naturalWidth) reveal();
        else logo.addEventListener('load', reveal, { once: true, signal: this.abort.signal });
      }
      disconnectedCallback() {
        this.finishTitle?.();
        this.finishBrand();
        clearTimeout(this.warmup);
        this.abort?.abort();
        this.swiper?.destroy(true, true);
        this.swiper = null;
        this.removeAttribute('data-ready');
        this.slides?.forEach((slide, index) => {
          slide.inert = index !== 0;
          slide.setAttribute('aria-hidden', String(index !== 0));
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
